export default __webpack_public_path__ + "static/media/rkon.711dd2b1.png";